var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8741 0.10906C19.7604 0.0101375 19.6033 -0.0147914 19.4664 0.0443564L1.15019 7.92498C1.00043 7.99003 0.903546 8.14325 0.905297 8.31226C0.907047 8.48128 1.00708 8.63228 1.15815 8.69396L6.20069 10.7338C6.32458 10.7841 6.46439 10.7667 6.57339 10.6873L13.2628 5.73167C13.4327 5.60372 13.6687 5.63492 13.8026 5.803C13.9364 5.97109 13.9222 6.21849 13.7701 6.36876L8.19557 11.964C8.1177 12.0422 8.07372 12.15 8.07372 12.2626V17.8479C8.07424 18.0348 8.19469 18.1982 8.36787 18.2471C8.54105 18.2959 8.72419 18.2181 8.81513 18.057L11.3372 13.5567C11.3919 13.4597 11.5108 13.4255 11.6056 13.4796L16.2451 16.1341C16.3553 16.1973 16.4877 16.2026 16.6022 16.1484C16.7167 16.0942 16.7998 15.9867 16.8265 15.8587L20.0119 0.512216C20.0398 0.361733 19.987 0.207351 19.8741 0.10906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportEmail);
export default __webpack_public_path__ + "static/media/report-email.e53a3bc80c38f53870be4eff0f8083cd.svg";
export { ForwardRef as ReactComponent };